import {
  DetailsPlainLanguage,
  DocumentsPlainLanguage,
  MainPlainLanguage,
  ProtectionType,
  Quote as QuoteData,
} from '../types/quote';
import i18next, { TFunction } from 'i18next';
import en from '../locales/en/translation.json';
import fr from '../locales/fr/translation.json';
import sv from '../locales/sv/translation.json';
import LanguageDetector from 'i18next-browser-languagedetector';

const ProtectionTypeArray = Object.values(ProtectionType);

export class Quote {
  static tPromise: Promise<TFunction> = i18next.use(LanguageDetector).init({
    // TODO: Update the below line when ready to deploy fr/sv
    supportedLngs: ['en'],
    resources: {
      en: {
        translation: en,
      },
      fr: {
        translation: fr,
      },
      sv: {
        translation: sv,
      },
    },
  });
  quoteData: QuoteData;
  main: MainPlainLanguage;
  details: DetailsPlainLanguage;
  documents: DocumentsPlainLanguage;

  constructor(quoteData?: QuoteData) {
    this.quoteData = quoteData;
    if (
      quoteData &&
      quoteData.exposureProtections.some(
        (exposureProtection) =>
          !ProtectionTypeArray.includes(exposureProtection.name),
      )
    ) {
      throw 'Unsupported protection type';
    }

    if (quoteData) {
      this.main = quoteData.plainLanguage.main;
      this.details = quoteData.plainLanguage.details;
      this.documents = quoteData.plainLanguage.documents;
      delete quoteData.plainLanguage;
    } else {
      Quote.tPromise.then((translations) => {
        this.main = {
          title: translations(`main.title`),
          body: translations(`main.body`),
          loading: translations(`main.loading`),
          action: translations(`main.action`),
          open_details: translations(`main.open_details`),
          details_action: translations(`main.details_action`),
          disclaimer: translations(`main.disclaimer`),
          suggested_price: translations(`main.suggested_price.loading`),
          suggested_price_total: '',
        };
        this.details = {
          title: '',
          summary_heading: '',
          summary_times: '',
          summary_tiers: [],
          summary_subheading: '',
          summary_body: '',
          summary_body_alt_unit: '',
          summary_explainer: '',
          steps_heading: '',
          step_1_heading: '',
          step_1_body: '',
          step_2_heading: '',
          step_2_body: '',
          step_3_heading: '',
          step_3_body: '',
          suggested_price: '',
          suggested_price_total: '',
          action: '',
          close: '',
          disclaimer: '',
        };
        this.documents = {
          privacy_policy: {
            title: translations(`documents.privacy.title`),
            link: translations(`documents.privacy.link`),
          },
          terms_conditions: {
            title: translations(`documents.terms_conditions.title`),
            link: translations(`documents.terms_conditions.link`),
          },
        };
      });
    }
  }
}
